module.exports = __webpack_public_path__ + "img/charge001.6a3967f2.png";